module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Regular.6f876d09.woff2";